/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/styles/makeStyles';
import { CardActionArea } from '@material-ui/core';
import { SwitchAccountCardHeader } from './SwitchAccountCardHeader';
import { SwitchAccountCardBody } from './SwitchAccountCardBody';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  cardContent: {
    padding: '0',
    margin: '0 1.2rem 0 1.2rem',
  },
  highlight: {
    // todo fix hightlight
    background: ({ highlight }) => highlight,
    width: '.5rem',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  buttonsContainer: {
    display: 'grid',
    gridGap: '1rem',
    gridTemplateColumns: '1fr 1fr',
  },
  createButton: {
    width: '100%',
  },
}));

export function SwitchAccountCard({ id, className, name, initials, type, roles, onClick, color }) {
  const classes = useStyles({ highlight: color });

  return (
    <CardActionArea onClick={onClick}>
      <Card className={classes.root}>
        <SwitchAccountCardHeader name={name} initials={initials} aria-label={id} id={id} className={className} />
        <CardContent className={classes.cardContent}>
          <span className={classes.highlight} aria-hidden="true" />
          <Grid container spacing={1}>
            <Grid itemxs={3}>
              <SwitchAccountCardBody type={type} roles={roles} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </CardActionArea>
  );
}
